<template>
  <div class="wtv-form-control" :class="classOfType" ref="control">
    <div
      class="wtv-form-label"
      v-show="output || state.inputValue || error"
      :class="{ 'wtv-red': error }"
    >
      {{ error || label }}
    </div>
    <input
      class="wtv-form-input"
      @click="openOptions"
      :class="{ 'is-set': output }"
      :value="output || state.inputValue"
      :readonly="readonly"
      :placeholder="placeholder ? placeholder : label"
      @input="handleInput"
    />
    <div
      v-if="!error && (output || state.inputValue)"
      class="wtv-select-chevron wtv-icon"
      :class="{ 'wtv-open': state.open, 'wtv-red': error }"
    ></div>
    <div
      v-else-if="
        required &&
          (!output || output.length === 0) &&
          state.inputValue.length === 0
      "
      class="wtv-form-input-requirator wtv-icon"
      :class="{ 'wtv-red': error }"
    ></div>
    <transition name="fade">
      <div
        v-show="(!options || (options && options.length)) && state.open"
        style="position: relative; z-index: 2"
      >
        <Calendar
          ref="calendar"
          v-if="type === 'datepicker'"
          :open="state.open"
          :onSelect="handleSelect"
          :class="{ 'wtv-stick-to-right': state.stickToRight }"
          :onDateSelect="onDateSelect"
          :hasSecondDate="hasSecondDate"
          :onSecondDateSelect="onSecondDateSelect"
          :hasDisabled="hasDisabled"
          :df="df"
          :hasYear="hasYear"
        />
        <!-- <Nights
          v-else-if="type === 'nights'"
          :open="state.open"
          :onSelect="handleSelect"
          :class="{ 'wtv-stick-to-right': state.stickToRight }"
        />-->
        <!-- <Passengers
          v-else-if="type === 'passengers'"
          :open="state.open"
          :onSelect="handleSelect"
          :class="{ 'wtv-stick-to-right': state.stickToRight }"
        /> -->
        <Options
          v-else
          :size="size"
          :onSelect="handleSelect"
          :options="options"
          :open="state.open"
          :type="type"
          :selected="selected"
          :class="{ 'wtv-stick-to-right': state.stickToRight }"
        />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import Options from '@/components/controls/Options.vue';
import Calendar from '@/components/controls/Calendar.vue';
// import Nights from '@/components/controls/Nights.vue';
// import Passengers from '@/components/controls/Passengers.vue';
import {
  defineComponent, computed, reactive, ref,
} from 'vue';
// import { useStore } from 'vuex';
// import { dateFromString } from '../../functions';

export default defineComponent({
  components: {
    Options,
    Calendar,
    // Nights,
    // Passengers,
  },
  props: {
    type: String,
    label: String,
    placeholder: String,
    output: String,
    size: String,
    onSelect: Function,
    afterSelect: Function,
    options: Array,
    selected: [Number, String],
    error: String,
    readonly: { type: Boolean, default: true },
    onInput: Function,
    required: Boolean,

    // calendar
    onDateSelect: Function,
    hasSecondDate: Boolean,
    onSecondDateSelect: Function,
    hasDisabled: { type: Boolean, default: true },
    hasYear: Boolean,
    df: Date,
  },
  setup(props) {
    // const $store = useStore();
    const state = reactive({
      inputValue: '',
      open: false,
      stickToRight: false,
    });

    const classOfType = computed(() => `wtv-form-control-${props.type}`);

    const control = ref({});
    const openOptions = (_: Event, open: boolean | undefined = undefined) => {
      state.open = open !== undefined ? open : !state.open;
      const checkRange = () => {
        if (
          window.innerWidth
            - (control.value as HTMLDivElement).getBoundingClientRect().right
          < 100
        ) { state.stickToRight = true; } else state.stickToRight = false;
      };
      const closeOptions = (e: Event) => {
        // eslint-disable-next-line no-param-reassign
        e = e || window.event;
        if (
          control.value
          && (control?.value as HTMLDivElement).contains(e.target as HTMLElement)
        ) { return false; }

        state.open = false;
        window.removeEventListener('click', closeOptions);
        return false;
      };
      if (state.open) {
        setTimeout(() => window.addEventListener('click', closeOptions), 0);
        checkRange();
      }
    };

    const handleSelect = () => {
      if (props.onSelect) props.onSelect(window.event);
      if (props.afterSelect) props.afterSelect();
      state.open = false;
    };

    const calendar = ref({});
    const handleInput = (e = window.event) => {
      const { value } = e?.target as HTMLInputElement;
      if (props.onInput) props.onInput();
      state.inputValue = value;
      if (props.type === 'datepicker' && value.length === 10) {
        state.open = false;
        return;
      }
      state.open = true;
    };

    return {
      state,
      control,
      calendar,
      openOptions,
      handleSelect,
      handleInput,
      classOfType,
    };
  },
});
</script>

<style scoped>
.wtv-form-control-nights {
  flex: 2 1 100px;
}
.wtv-form-control-Passengers {
  flex: 2 1 140px;
}
.wtv-select-chevron {
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 15px 12px 15px;
  cursor: pointer;
  transition: 0.3s;
  background: none;
}
.wtv-select-chevron {
  pointer-events: none;
}
.wtv-select-chevron:before {
  color: var(--color-alt);
  font-size: 18px;
  content: '\f078';
  display: block;
}
.wtv-select-chevron.wtv-open:before {
  transform: rotate(-180deg);
  transition: transform 0.3s;
}
.wtv-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}
.wtv-form-input:focus::placeholder {
  color: var(--color-alt);
}
.wtv-form-input-requirator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 10px 14px;
  cursor: pointer;
  pointer-events: none;
  transition: 0.3s;
}
.wtv-form-input-requirator:before {
  content: '\f069';
  color: var(--color-text-5);
  font-size: 12px;
}
.wtv-red,
.wtv-red:before {
  color: var(--color-second);
}
</style>
